<script>
  import { createEventDispatcher } from 'svelte'

  const dispatch = createEventDispatcher()

  const user = {
    identity: null,
    secret: null,
  }

  let isShowingPassword = false
  let passwordField = null

  function togglePassword() {
    isShowingPassword = !isShowingPassword
    passwordField.type = (isShowingPassword ? 'text' : 'password')
  }

  function sendUser() {
    dispatch('formEdited', user)
  }
</script>

<label class="auth__label" for="email">

  Email Address

  <div class="auth__input">

    <input type="text" name="email" on:keyup={sendUser} placeholder="Your email..." bind:value={user.identity} id="email" required>

  </div>

</label>

<label class="auth__label" for="password">

  Password

  <div class="auth__input">

    <input type="password" on:keyup={sendUser} bind:this={passwordField} name="password" placeholder="Password" bind:value={user.secret} id="password" required>

    {#if !isShowingPassword}

      <img src="/static/icons/eye.svg" alt="" on:click={togglePassword}>

    {:else}

      <img src="/static/icons/eye-closed.svg" alt="" on:click={togglePassword}>

    {/if}

  </div>
  
</label>